export default {
  name: { id: 'name' },
  edit: { id: 'edit' },
  translationList: { id: 'translation_list' },
}
